export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_rose.fcc6df1e.jpg";